import * as React from 'react';
import './ReportingTagPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { IReportingTagReduxFormState, initialReportingTagState } from "../../../reducers/reactReduxForms/reportingTag";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput, SelectFormInput } from "../../../components/form/index";
import * as ReportingTagActions from '../../../actions/reportingTags';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { QALookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';
interface IReportingTagPageParams {
  reportingTagId: number;
}
interface IReportingTagPageProps {
  form: Dtos.ReportingTag & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: IReportingTagReduxFormState;
  location: Location;
  reportingTagId: number;
  match: match<IReportingTagPageParams>;
  history: History;

  // From state
  reportingTag: Dtos.ReportingTag;
  lookups: Dtos.Lookup[];
  loadingReportingTag: boolean;
  loadReportingTagSuccess: boolean;
  loadReportingTagFailure: boolean;
  savingReportingTag: boolean;
  saveReportingTagSuccess: boolean;
  saveReportingTagFailure: boolean;
  creatingReportingTag: boolean;
  createReportingTagSuccess: boolean;
  createReportingTagFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
}
interface IReportingTagPageActions {
  clearReportingTag: ReportingTagActions.IReportingTagClearActionCreator;
  loadReportingTag: ReportingTagActions.IReportingTagLoadByIdActionCreator;
  saveReportingTag: ReportingTagActions.IReportingTagSaveActionCreator;
  createReportingTag: ReportingTagActions.IReportingTagCreateActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type ReportingTagPageProps = IReportingTagPageProps & IReportingTagPageActions;
const reduxFormName: string = "reduxForms.reportingTag";
class ReportingTagPage extends React.PureComponent<ReportingTagPageProps, any> {
  constructor(props: ReportingTagPageProps) {
    super(props);
    this.clearReportingTag = this.clearReportingTag.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
  }
  componentDidMount() {
    const {
      loadReportingTag,
      reportingTagId,
      createReportingTag
    } = this.props;
    if (reportingTagId) {
      loadReportingTag(reportingTagId);
    } else if (!reportingTagId) {
      createReportingTag();
    }
  }
  componentWillReceiveProps(nextProps: ReportingTagPageProps) {}
  componentDidUpdate(prevProps: ReportingTagPageProps, prevState) {
    const {
      reportingTagId,
      reportingTag,
      form,
      navigate,
      loadReportingTag,
      loadingReportingTag,
      loadReportingTagSuccess,
      createReportingTag,
      creatingReportingTag,
      createReportingTagSuccess,
      savingReportingTag,
      saveReportingTagSuccess,
      validationFailures
    } = this.props;
    if (reportingTagId && prevProps.reportingTagId != reportingTagId) {
      loadReportingTag(reportingTagId);
    } else if (!reportingTagId && prevProps.reportingTagId) {
      createReportingTag();
    }
    if (!loadingReportingTag && prevProps.loadingReportingTag) {
      if (loadReportingTagSuccess) {
        this.loadForm();
      }
    }
    if (!savingReportingTag && prevProps.savingReportingTag) {
      if (saveReportingTagSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/settings/qa/reportingTags");
        } else if (!form.saveAndReturn && reportingTagId && reportingTagId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !reportingTagId && reportingTag && reportingTag.id > 0) {
          navigate("/settings/qa/reportingTags/" + reportingTag.id);
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingReportingTag && prevProps.creatingReportingTag) {
      if (createReportingTagSuccess) {
        this.loadForm();
      }
    }
  }
  componentWillUpdate(nextProps: ReportingTagPageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearReportingTag();
    loadForm(reduxFormName, initialReportingTagState);
    resetForm(reduxFormName);
  }
  clearReportingTag() {
    this.props.clearReportingTag();
  }
  showReportingTag(): boolean {
    const {
      loadingReportingTag,
      loadReportingTagSuccess
    } = this.props;
    if (!loadingReportingTag && loadReportingTagSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingReportingTag
    } = this.props;
    return <QALookupsLayout loading={loadingReportingTag} permission={Dtos.Permission.ReportingTagsView} data-sentry-element="QALookupsLayout" data-sentry-component="ReportingTagPage" data-sentry-source-file="ReportingTagPage.tsx">
            {this.renderContent()}
        </QALookupsLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      savingReportingTag,
      permissions
    } = this.props;
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.ReportingTagsUpdate, Dtos.Permission.ReportingTagsCreate);
    const formDisabled: boolean = !hasPermission || savingReportingTag || formState && formState.formStatus == Dtos.FormStatus.Disabled; // || savingDemographicDetailForm;

    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      value: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled
      },
      reportingTagCategoryId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("ReportingTag", "ReportingTagCategoryId", lookups), form.reportingTagCategoryId)
        },
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          changeForm(reduxFormName + ".reportingTagCategory", null);
        }
      },
      rank: {
        type: RegistrationComponent.RegistrationControl,
        inputType: NumberFormInput,
        inputDisabled: formDisabled
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " "
      }
    };

    /*
     reportingTagCategoryId: {
            type: RegistrationComponent.RegistrationControl,
            inputType: SelectFormInput,
            inputDisabled: formDisabled,
            inputProps: {
                options: generateOptionsFromLookup(findLookup("ReportingTag", "ReportingTagCategoryId", lookups), form.reportingTagCategoryId)
            }
        },
     */

    return <div>
            <h1>Reporting Tag</h1>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                {renderFormControls(form, "reportingTag", formComponents, lookups, validationFailures, formProperties, changeForm)}
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>

        </div>;
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
            </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.ReportingTag) {
    const {
      saveReportingTag
    } = this.props;
    if (data) {
      let changes: Dtos.ReportingTag = ({} as Dtos.ReportingTag);
      saveReportingTag(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.ReportingTag) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      navigate
    } = this.props;
    navigate("/settings/qa/reportingTags");
  }
  loadForm() {
    const {
      loadForm,
      reportingTag
    } = this.props;
    let extraData: Dtos.ReportingTag = ({} as Dtos.ReportingTag);
    loadForm(reduxFormName, Object.assign({
      ...reportingTag
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: ReportingTagPageProps): IReportingTagPageProps => {
  let reportingTag: Dtos.ReportingTag | undefined = !(state.reportingTags.formData instanceof Array) ? state.reportingTags.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    reportingTagId: ownProps.match && ownProps.match.params.reportingTagId && ownProps.match.params.reportingTagId.toString() != "create" ? ownProps.match.params.reportingTagId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    reportingTag: reportingTag!,
    loadingReportingTag: state.reportingTags.loadState && state.reportingTags.loadState.status == RequestState.Pending,
    loadReportingTagSuccess: state.reportingTags.loadState && state.reportingTags.loadState.status == RequestState.Success,
    loadReportingTagFailure: state.reportingTags.loadState && state.reportingTags.loadState.status == RequestState.Failure,
    savingReportingTag: state.reportingTags.saveState && state.reportingTags.saveState.status == RequestState.Pending,
    saveReportingTagSuccess: state.reportingTags.saveState && state.reportingTags.saveState.status == RequestState.Success,
    saveReportingTagFailure: state.reportingTags.saveState && state.reportingTags.saveState.status == RequestState.Failure,
    creatingReportingTag: state.reportingTags.createState && state.reportingTags.createState.status == RequestState.Pending,
    createReportingTagSuccess: state.reportingTags.createState && state.reportingTags.createState.status == RequestState.Success,
    createReportingTagFailure: state.reportingTags.createState && state.reportingTags.createState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    lookups: state.reportingTags.lookups,
    form: state.reduxForms.reportingTag,
    formState: state.reportingTags.formState,
    formProperties: state.reportingTags.formProperties,
    reduxFormState: state.reduxForms.formState.reportingTag,
    validationFailures: reportingTag ? state.reportingTags.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): IReportingTagPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadReportingTag: bindActionCreators(ReportingTagActions.LoadReportingTagById, dispatch),
    clearReportingTag: bindActionCreators(ReportingTagActions.Clear, dispatch),
    saveReportingTag: bindActionCreators(ReportingTagActions.SaveReportingTag, dispatch),
    createReportingTag: bindActionCreators(ReportingTagActions.CreateReportingTag, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportingTagPage);